import { useReactiveVar } from '@apollo/client';
import { theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import { groupBy } from 'lodash';
import { useTranslation } from 'react-i18next';
import { country } from 'states/persistInStorage';
import { ParkingFacilityProps } from 'types/generatedSchemaTypes';
import { getOpeningEndingTimeToday } from 'utils/timeUtils';
import ZoneDetailsRow from './ZoneDetailsRow';
import { useUiStore } from 'stores/uiStore';

const ParkingSchedule = ({
  parkingFacilityData,
}: {
  parkingFacilityData?: ParkingFacilityProps | null;
}) => {
  const { t } = useTranslation();
  const countryCode = useReactiveVar(country);

  if (!parkingFacilityData?.timeSlots) {
    return <></>;
  }

  const schedule = parkingFacilityData?.timeSlots;
  const groupedSchedule = groupBy(schedule, 'weekDay');

  const driveInOpeningClosingTime = getOpeningEndingTimeToday(
    groupedSchedule,
    new Date(),
    countryCode
  );

  // TODO: add sheet modal showing opening times when pressed
  return (
    <ZoneDetailsRow
      icon={<Icon name="Time-Filled" size="m" color={theme.colors.primary} />}
      title={driveInOpeningClosingTime?.text || ''}
      linkText={t('parking.openHours')}
      onPress={() => useUiStore.getState().setSheetModal('parkingHours')}
      testIDprefix="open-hours"
      chevronSize="m"
      chevronColor={theme.colors.primary}
      linkColor={theme.colors.primary}
      borderBottom={true}
    />
  );
};

export default ParkingSchedule;
